// extracted by mini-css-extract-plugin
export default {"container":"PricingPage_container__Inx15"};